{
  "Back": "Zurück",
  "Invoice": "Rechnung",
  "Payment Due": "Fällige Zahlung",
  "Paid": "Bezahlt",
  "Download PDF": "PDF Herunterladen",
  "Pay Invoice": "Rechnung Bezahlen",
  "Invoice Date": "Rechnungsdatum",
  "Due Date": "Fälligkeitsdatum",
  "Auto-Pay On": "Automatische Zahlung An",
  "Auto-Pay Off": "Automatische Zahlung Aus",
  "Invoice Total": "Rechnungssumme",
  "Balance due": "Offener Betrag",
  "Bill To": "Rechnung an",
  "Account Number": "Kontonummer",
  "Account Balance": "Kontostand",
  "Bill From": "Rechnung von",
  "Check payment instructions": "Anweisungen zur Zahlung per Scheck",
  "If paying via check": "Wenn Sie per Scheck zahlen, stellen Sie den Scheck aus auf {{recipient}}, geben Sie Ihre Kontonummer ({{accountNumber}}) und die Standort-ID ({{locationId}}) im 'Memo'-Feld an, und fügen Sie eine Kopie dieser Rechnung dem Scheck bei:",
  "USPS": "Wenn Sie per USPS-Standardversand senden, senden Sie es an Industrious Office, P.O. Box 780441, Philadelphia PA 19178-0441.",
  "courier": "Wenn Sie per Kurier oder Expressversand senden, senden Sie es an Wells Fargo Lockbox Services, Industrious Office, Lockbox – 780441, MAC: Y1372-045, 401 Market Street, Philadelphia PA 19106.",
  "Payment is due on the invoice due date": "Die Zahlung ist am Fälligkeitsdatum der Rechnung fällig. Eine Verzugsgebühr von 10 % wird auf offene Salden erhoben, die mehr als 5 Tage nach ihrem Fälligkeitsdatum liegen. Wenn Sie bereits für die automatische Zahlung per ACH-Lastschrift oder Kreditkarte angemeldet sind, wird Industrious Ihr Konto am Fälligkeitsdatum der Rechnung belasten, und es ist keine Aktion erforderlich.",
  "To the extent applicable": "Soweit dies für die erbrachten Dienstleistungen oder die an Sie gewährte Lizenz zutrifft und soweit die Haftung von Industrious beschränkt ist, gelten die Nutzungsbedingungen und die Datenschutzrichtlinie von Industrious, die unter",
  "incorporated": "durch Bezugnahme aufgenommen und regeln unsere Vereinbarung, als wären Sie Mitglied und Lizenznehmer des Industrious-Bürogebäudes. Die Zahlung stellt die Annahme aller Bedingungen dieser Rechnung durch Sie dar.",
  "Please contact billing@industriousoffice.com with any questions regarding your invoice.": "Bitte kontaktieren Sie billing@industriousoffice.com bei Fragen zu Ihrer Rechnung.",
  "MAC": "MAC: Y1372-045, 401 Market Street, Philadelphia PA 19106.",
  "Applied Credit": "Verrechnetes Guthaben",
  "As of {{date}}, this invoice is not scheduled for auto-pay.": "Ab dem {{date}} ist diese Rechnung nicht für die automatische Zahlung vorgesehen.",
  "As of {{date}}, this invoice is scheduled for auto-pay.": "Ab dem {{date}} ist diese Rechnung für die automatische Zahlung vorgesehen.",
  "Item": "Artikel",
  "Description": "Beschreibung",
  "Service Period": "Leistungszeitraum",
  "Unit Price": "Stückpreis",
  "Quantity": "Menge",
  "Amount": "Betrag"
}
